import { IMG } from '../../const';
import '../../assets/styles/report.scss';
import {
  deliverable_1,
  deliverable_2,
  design_roadmap,
  design_team,
} from './tabsConst';
import { combineDays } from '../../helpers';

const DesignTab = ({ activeOption, designPrice, designTime, days }) => {
  const getRunTime = days ? combineDays(days.min, days.max) : '14-20 days';

  return (
    <div
      className={`report-page__tab${
        activeOption.id === 'design' ? ' activeTab' : ''
      }`}
    >
      <div className="summary-block">
        <div className="summary-block__label">Summary</div>
        <ul className="summary-block__list">
          <li>
            <div>90%</div>
            <div>accuracy</div>
          </li>
          <li>
            <div>2</div>
            <div>people in team</div>
          </li>
          <li>
            <div>{designPrice || '€3–5,3K'}</div>
            <div>budget range</div>
          </li>
          <li>
            <div>{designTime || '5'}</div>
            <div>weeks</div>
          </li>
        </ul>
      </div>

      <div className="features-block">
        <div className="features-block__item">
          <div className="features-block__item-title">Prototyping</div>
          <p>
            The Prototyping Phase helps you visualize your product before any
            code is written. It’s the fastest and most cost-efficient way to
            test ideas, align stakeholders, and validate your concept with users
            or investors — without committing to full development.
          </p>
        </div>

        <div className="features-block__item height-fit-content">
          <div className="features-block__item-title">Team</div>
          <ul>
            {design_team.map((member) => (
              <li key={member.id}>
                {member.amount} {member.name}
              </li>
            ))}
          </ul>
        </div>

        <div className="features-block__item__wide">
          <div className="features-block__item-title">Deliverables</div>
          <div className="features-block__item-sub">
            <p>
              These deliverables will allow you to start development with any
              vendor
            </p>
          </div>
          <div className="features-block__item-flex">
            <div>
              <ul>
                {deliverable_1.map((item) => (
                  <li key={item.id}>{item.name}</li>
                ))}
              </ul>
            </div>
            <div>
              <ul>
                {deliverable_2.map((item) => (
                  <li key={item.id}>{item.name}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="summary-block">
        <div className="summary-block__label">Roadmap</div>
        <ul className="summary-block__roadmap">
          {design_roadmap.map((item) => (
            <li key={item.id}>
              <div className="summary-block__roadmap-text">
                <img
                  src={`${IMG.QUICK_QUOTE}/icons/${item.icon}.svg`}
                  width="44"
                  height="44"
                  loading="lazy"
                  alt={item.title}
                />
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
              <div className="summary-block__roadmap-runtime">
                {item.id != 4 ? item.runtime : getRunTime}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DesignTab;
